import { RootStore } from './rootStore';
import { observable, computed, makeObservable } from 'mobx';
import { configure } from 'mobx';
import { IUserInfo, IUserRole, UserRoles, UserType } from '../data/userRole';
import { getActiveAccount } from '../Authentication';

configure({ enforceActions: 'always' });

export default class CommonStore {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            _currentUser: observable,
          appLoaded: observable,
            userType: computed,
            userInfo: computed
        })
    }

    appLoaded = false;
    _currentUser: IUserInfo | null = null;

    get userType(): UserType {
        return this.userInfo.type;
    }

    get userInfo(): IUserInfo {

      if (this._currentUser)
        return this._currentUser;

      const account = getActiveAccount();
      if (account) {
        let role: IUserRole | undefined = undefined;
        if (account.idTokenClaims) {
          const roles = (<any>account.idTokenClaims).roles as Array<string>;
          if (roles && roles.length > 0) {
            role = UserRoles[roles[0]];
          }
        }

        this._currentUser = {
          ...(role || UserRoles.Reader),
          userName: account.username,
          userFullName: account.name
        };
        return this._currentUser;
      }

      return process.env.REACT_APP_USER_ROLE ? UserRoles[process.env.REACT_APP_USER_ROLE] : { ...UserRoles.Reader };
    }
}